import script from "./DevicePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./DevicePreview.vue?vue&type=script&setup=true&lang=ts"

import "./DevicePreview.vue?vue&type=style&index=0&id=b309e82c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b309e82c"]])

export default __exports__